export interface ThreadMessageProps {
  from: string;
  email?: string;
  when: string;
  snippet: string;
  /** plain-text body; null while loading or when unavailable */
  body: string | null;
  state: "loading" | "ready" | "error";
  /** shown under the snippet when the body couldn't be loaded */
  note?: string;
}

/** One message in the thread view. Plain text only until packages/sanitize (M2). */
export function ThreadMessage(p: ThreadMessageProps) {
  return (
    <article className="message" data-state={p.state}>
      <header className="message-head chrome">
        <span className="message-from">
          {p.from}
          {p.email && p.email !== p.from ? <span className="muted"> &lt;{p.email}&gt;</span> : null}
        </span>
        <span className="when m muted">{p.when}</span>
      </header>
      {p.state === "ready" && p.body !== null ? (
        <div className="message-body reading">{p.body}</div>
      ) : (
        <div className="message-body reading">
          <p className="muted">{p.snippet}</p>
          <p className="m muted message-note">{p.state === "loading" ? "Loading the message…" : (p.note ?? "The full message isn't available offline.")}</p>
        </div>
      )}
    </article>
  );
}
